import type {ReactElement} from 'react';
import React, { useEffect, useRef} from 'react';
import {createTextMask} from '@Libraries/text-mask';
import MaskingImageContainer from '@Panels/masking-panel/components/masking-image-container';
import type {MaskingItemObject} from '@PosterWhiteboard/classes/item-masking.class';
import type {CropData} from '@PosterWhiteboard/classes/item-crop.class';

export interface TextMaskingCanvasProps {
  id: string;
  url: string;
  isSmallScreen: boolean;
  initialMaskingData?: MaskingItemObject;
  cropData?: CropData;
}

const parentContainer = 'text-masking-container';

function TextMaskingCanvas({...props}: TextMaskingCanvasProps): ReactElement {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect((): void => {
    createTextMask(props.id, props.url, `.${parentContainer}`, {
      initialMaskingData: props.initialMaskingData,
      cropData: props.cropData,
    })
      .then((textMaskCanvas) => {
        window.textMask = textMaskCanvas;
      })
      .catch((e) => {
        throw e;
      });
  }, []);

  return (
    <MaskingImageContainer isSmall={props.isSmallScreen} additionalClasses={parentContainer}>
      <canvas id={props.id} ref={canvasRef} />
    </MaskingImageContainer>
  );
}

export default TextMaskingCanvas;
